import RichTextEditor from "./widgets/Editor/RichTextEditor";

const exports = {
    widgets: {
        Editor: RichTextEditor,
    }
}
export default exports;